import { render, staticRenderFns } from "./projectWeeklyList.vue?vue&type=template&id=72bd2d22&scoped=true&"
import script from "./projectWeeklyList.vue?vue&type=script&lang=js&"
export * from "./projectWeeklyList.vue?vue&type=script&lang=js&"
import style0 from "./projectWeeklyList.vue?vue&type=style&index=0&id=72bd2d22&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bd2d22",
  null
  
)

export default component.exports